const toPlainText = (size = 'primary', blocks = []) => {
  const sizes = {
    primary: '-top-[13px] md:-top-[30px]',
    secondary: '-top-[9px] md:-top-[22px]',
  }

  return blocks.map((block) => {
    if (block._type !== 'block' || !block.children) {
      return <></>
    }

    return block.children.map((child) => {
      if (child.marks[0] === 'sup') {
        return (
          <span className={`relative text-[60%] ${sizes[size]} !inline`}>
            {child.text}
          </span>
        )
      } else if (child.marks[0] === 'strong') {
        return <b>{child.text}</b>
      } else if (child.marks[0] === 'sub') {
        return <sub>{child.text}</sub>
      } else if (child.marks[0] === 'em') {
        return <i>{child.text}</i>
      } else if (child.marks[0] === 'underline') {
        return (
          <span className="underline underline-offset-4">{child.text}</span>
        )
      } else {
        return child.text
      }
    })
  })
}

export default toPlainText
